import { render } from "./or-admin-save-button.vue?vue&type=template&id=1cdfabc2&scoped=true&bindings={\"options\":\"props\",\"selected_page\":\"props\",\"deleted\":\"props\",\"save\":\"options\"}"
import script from "./or-admin-save-button.vue?vue&type=script&lang=js"
export * from "./or-admin-save-button.vue?vue&type=script&lang=js"

import "./or-admin-save-button.vue?vue&type=style&index=0&id=1cdfabc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cdfabc2"

export default script